import React, { FC, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import './NavbarDropDown.scss';
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from 'react-icons/io';
import Item from './Item';
import { NavbarDropDownProps } from './models';
import { NavBarI } from 'app/adapters/NavBar';
import classNames from 'classnames';
import useClickOutside from 'app/hooks/useClickOutside';

const NavbarDropDown: FC<NavbarDropDownProps> = ({ menuItems }) => {
  const [activeSubNav, setactiveSubNav] = useState<null | NavBarI[]>(null);
  const [activeSecondSubNav, setactiveSecondSubNav] = useState<
    null | NavBarI[]
  >(null);
  const [offSetLeft, setOffSetLeft] = useState(0);
  const subNavRef = useRef<HTMLDivElement | null>(null);
  const mainNavRef = useRef<HTMLUListElement | null>(null);
  let { slug } = useParams<{ slug: string }>();

  useClickOutside(subNavRef, mainNavRef, () => {
    if (activeSubNav) {
      setactiveSubNav(null);
    }
  });

  const subNavClasses = classNames(
    {
      [`sub-nav--active`]: activeSubNav,
    },
    'sub-nav',
  );
  const secondSubNavClasses = classNames(
    {
      [`sub-nav__second--active`]: activeSecondSubNav,
    },
    'sub-nav__second',
  );
  const lineHorizontalClasses = classNames(
    {
      [`line-horizontal--active`]: activeSecondSubNav,
    },
    'line-horizontal',
  );

  useEffect(() => {
    setactiveSubNav(null);
  }, [slug]);

  return (
    <>
      <nav className="main-nav" ref={mainNavRef}>
        <ul className="main-nav__list">
          {menuItems?.map((menu, index) =>
            menu.path || menu.page ? (
              menu.path ? (
                <li className="main-nav__item" key={index}>
                  <Link to={`/${menu.path}`}>{menu.name}</Link>
                </li>
              ) : menu.page ? (
                <li className="main-nav__item" key={index}>
                  <Link to={`/${menu.page.slug}`}>{menu.name}</Link>
                </li>
              ) : null
            ) : menu.children.length ? (
              <Item
                key={index}
                menu={menu}
                setactiveSubNav={setactiveSubNav}
                setactiveSecondSubNav={setactiveSecondSubNav}
                setOffSetLeft={setOffSetLeft}
              />
            ) : null,
          )}
        </ul>
      </nav>
      <div className={subNavClasses} ref={subNavRef}>
        <div
          className="sub-navs-container"
          style={{ transform: `translateX(${offSetLeft}px)` }}
        >
          <ul className="sub-nav__list">
            {activeSubNav?.map((menu, index) => {
              return (
                <li
                  className="sub-nav__item"
                  key={index}
                  onClick={() => {
                    if (menu.children.length) {
                      if (activeSecondSubNav === menu.children)
                        setactiveSecondSubNav(null);
                      else setactiveSecondSubNav(menu.children);
                    }
                  }}
                >
                  {menu.path || menu.page ? (
                    menu.path ? (
                      <Link to={`/${menu.path}`} key={index}>
                        {menu.name}
                      </Link>
                    ) : menu.page ? (
                      <Link to={`/${menu.page.slug}`} key={index}>
                        {menu.name}
                      </Link>
                    ) : null
                  ) : menu.children.length ? (
                    <React.Fragment key={index}>{menu.name}</React.Fragment>
                  ) : null}

                  {menu.children.length ? (
                    <IoIosArrowForward
                      className={`sub-nav-arrow ${
                        activeSecondSubNav === menu.children
                          ? 'sub-nav-arrow--active'
                          : ''
                      }`}
                    />
                  ) : (
                    <></>
                  )}
                </li>
              );
            })}
          </ul>
          <div className={lineHorizontalClasses}></div>
          <ul className={secondSubNavClasses}>
            {activeSecondSubNav?.map((menu, index) => {
              return (
                <li className="sub-nav__second-item" key={index}>
                  {menu.path || menu.page ? (
                    menu.path ? (
                      <Link to={`/${menu.path}`} key={index}>
                        {menu.name}
                      </Link>
                    ) : menu.page ? (
                      <Link to={`/${menu.page.slug}`} key={index}>
                        {menu.name}
                      </Link>
                    ) : null
                  ) : null}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default NavbarDropDown;
